import { SubHeadline, Title } from '~components/Typography';
import { Flex } from '~shared/ui/atoms/Flex';

import { TabButton } from './styles';

type TabItem = {
	label: React.ReactNode;
	value: string;
};

type Props = {
	className?: string;
	tabs: TabItem[];
	active: string;
	size?: 'S' | 'M';
	fullWidth?: boolean;
	onChange: (value: string) => void;
};

export const TabMenu = ({
	className,
	tabs,
	active,
	size = 'M',
	fullWidth,
	onChange,
}: Props) => (
	<Flex className={className} justify="center" gap="m">
		{tabs.map(({ label, value }) => (
			<TabButton
				key={value}
				type="button"
				size={size}
				fullWidth={!!fullWidth}
				selected={value === active}
				onClick={() => onChange(value)}
			>
				{size === 'S' ? (
					<SubHeadline size="S">{label}</SubHeadline>
				) : (
					<Title size="S">{label}</Title>
				)}
			</TabButton>
		))}
	</Flex>
);
